<template>
  <section>
    <div class="role">
      <div class="roleRight" style="border-left: 0">
        <div class="roleRight_Top">
          <el-input
              size="mini"
              clearable
              v-model="search.keyword"
              clas="input_search"
              placeholder="搜索关键字"
              @keyup.enter.native="SearchRoleList"
          ></el-input>
          <el-select size="mini" v-model="search.status" clearable placeholder="请选择">
            <el-option label="正常" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
          <el-button size="mini" type="primary" @click="SearchRoleList"
          >查询
          </el-button
          >
          <el-button
              size="mini"
              type="primary"
              @click="handleClick('addNext')"
          >新增
          </el-button
          >
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table
              :data="tableData"
              size="medium"
              border
              style="width: 100%"
              row-key="roleId"
              v-loading="loading"
          >
            <el-table-column
                fixed
                label="序号"
                prop="roleId"
                type="index"
                width="80"
            >
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="模板名称" min-width="150">
            </el-table-column>
            <el-table-column prop="mark" label="模板标识" min-width="180">
            </el-table-column>
            <el-table-column prop="title" label="邮件标题" min-width="180">
            </el-table-column>
            <el-table-column prop="remark" label="备注" min-width="180">
            </el-table-column>
            <el-table-column prop="status" label="状态" width="150">
              <template slot-scope="scope">
                <el-switch
                    v-model="scope.row.status"
                    :active-value="1"
                    :inactive-value="0"
                    @change="handleStatusSwitch(scope.row.id)"
                ></el-switch>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" min-width="180">
              <template slot-scope="scope">
                <el-button
                    @click="handleClick('edit', scope.row)"
                    plain
                    size="small"
                >修改
                </el-button
                >
                <el-button
                    type="primary"
                    plain
                    size="small"
                    @click="del(scope.row)"
                >删除
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 编辑弹框 -->
    <el-dialog
        title="新增/编辑邮件模板"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="750px"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="100px"
        >
          <el-tabs type="card" v-model="languageCode" @tab-click="handleTabClick">
            <el-tab-pane v-for="(item,index) in languageList" :label="item.name" :name="item.code"
                         :key="index"></el-tab-pane>
          </el-tabs>
          <el-row>
            <el-col :span="12">
              <el-form-item label="模板标识：" prop="name">
                <el-input
                    clearable
                    placeholder="请填写模板标识"
                    v-model="params.mark"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="模板名称：" prop="name">
                <el-input
                    clearable
                    placeholder="请填写模板名称"
                    v-model="params.name"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="邮件标题：" prop="title">
                <el-input
                    clearable
                    placeholder="请填写邮件标题"
                    v-model="params.title"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="模板备注：" prop="remark">
                <el-input
                    clearable
                    placeholder="请填写模板备注"
                    v-model="params.remark"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="scheme" label="关联题型">
                <el-select
                    v-model="params.scheme"
                    clearable
                    placeholder="请选择题型"
                >
                  <el-option label="维度" value="wd"></el-option>
                  <el-option label="MBTI" value="mbti"></el-option>
                  <!-- <el-option label="高低分" value="mid"></el-option>
                  <el-option label="基准" value="jz"></el-option>
                  <el-option label="平均分" value="avg"></el-option>
                  <el-option label="大五人格" value="dwrg"></el-option>
                  <el-option label="潜意识" value="qys"></el-option>
                  <el-option label="基准倾向" value="jzqx"></el-option>
                  <el-option label="图谱" value="rgtp"></el-option>
                  <el-option label="评级" value="wdpj"></el-option>
                  <el-option label="色彩" value="wdsc"></el-option>
                  <el-option label="二级维度" value="ejwz"></el-option>
                  <el-option label="暗黑人格" value="ahrg"></el-option>
                  <el-option label="天才人格" value="tcrg"></el-option>     
                  <el-option label="维度年龄" value="wdnl"></el-option>
                  <el-option label="维度组合" value="wdzh"></el-option>
                  <el-option label="人格魅力" value="rgml"></el-option>
                  <el-option label="爱情三元" value="aqsy"></el-option>
                  <el-option label="马基雅维利" value="mjywl"></el-option> -->
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="关联应用：" prop="appId">
                <el-select
                    filterable
                    v-model="params.appId"
                    clearable
                    style="width: 100%"
                    placeholder="请选择应用"
                >
                  <el-option v-for="(item,index) in appList" :value="item.appInfoId + ''" :key="index"
                             :label="item.appName"></el-option>
                </el-select>
              </el-form-item> -->
            </el-col>
            <el-col :span="8">
              <el-form-item class="item" label="HTML：" prop="isHtml">
                <el-radio v-model="params.type" :label="2">是</el-radio>
                <el-radio v-model="params.type" :label="1">否</el-radio>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="详情：" v-if="params.type==2">
            <richText :keyWord="'content'" :params="params" v-if="flag"></richText>
          </el-form-item>
          <el-form-item label="邮件内容：" v-if="params.type==1">
            <el-input
                style="width: 100%"
                type="textarea"
                :rows="5"
                placeholder="请填写邮件内容"
                v-model="params.content"
                clearable
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
  </section>
</template>
<script>

import upLoadImg from "@views/international/components/upLoadImg";
import uploadCommonImg from "@comp/uploadCommonImg";
import richText from "@comp/richText";

export default {
  components: {upLoadImg, uploadCommonImg, richText},
  data() {
    return {
      loading: false,
      search: {},
      clickType: "", //弹窗类型
      params: {}, //弹窗修改数据
      rules: {
        name: [{required: true, message: "请填写名称", trigger: "blur"}],
        mark: [{required: true, message: "请填写标识", trigger: "blur"}],
        title: [{required: true, message: "请填写源语言", trigger: "blur"}],
        appId: [{required: true, message: "请选择关联应用", trigger: "blur"}],
      }, //表单验证提示
      tableData: [], //二级--角色列表，
      dialogVisible: false,
      changeTimer: false,
      plateList: [],
      languageList: [],
      currencyList: [],
      appList: [],
      flag: false,
      languageCode: ""
    };
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
        this.flag = false;
      }
    },
  },
  created() {
    this.getCountryList();
    this.getLanguageList();
    this.getAppList();
  },
  methods: {

    handleTabClick() {
      this.flag = false;
      if (this.params.id) {
        this.getCountryInfo()
      } else {
        this.$nextTick(() => {
          this.flag = true;
        });
      }
    },
    //获取语言列表
    async getLanguageList() {
      this.loading = true;
      //角色列表
      const {data: res} = await this.$post(
          `/language/list`, {adminStatus: 1},
      );
      this.loading = false;
      this.languageList = res.data;
      this.languageCode = res.data[0].code
    },

    async getAppList() {
      this.loading = true;
      //应用列表
      const {data: res} = await this.$get(
          `/app/list?appType=WEBSIT&pageNo=1&pageSize=100`
      );
      this.loading = false;
      this.appList = res.data;
    },

    SearchRoleList() {
      this.getCountryList()
    },
    async getCountryList() {
      this.loading = true;
      //角色列表
      const {data: res} = await this.$get(
          `/email/template/list`,{params:this.search},
      );
      this.loading = false;
      this.tableData = res.data;
    },
    //switch状态改变 --接口 修改角色状态
    handleStatusSwitch(id) {
      this.$get(`/email/template/change/${id}`).then(res => {
        if (res.data.result == 200) {
          this.$message.success('操作成功')
          this.getCountryList()
        }
      });
    },
    // 弹窗
    handleClick(type, row = {}) {
      this.clickType = type;
      this.dialogVisible = true;
      if (type == "addNext") {
        //编辑
        this.params = {type:2};
        this.$nextTick(() => {
          this.flag = true;
        });
      } else if (type == "edit") {
        //修改  change
        this.params = JSON.parse(JSON.stringify(row));
        this.getCountryInfo()
      }
    },
    async getCountryInfo() {
      this.flag = false
      const {data: resData} = await this.$post(
          `/email/template/info/${this.params.id}`,{},
          {
            headers: {
              isLoading: true,
              'Language-Code': this.languageCode
            },
          }
      );
      if (resData.result != 200) return;
      this.params = resData.data
      this.$nextTick(() => {
        this.flag = true;
      });
    },
    //窗口--提交 修改信息
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认提交修改, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          const {data: resData} = await this.$post("/email/template/edit", this.params, {
            headers: {
              isLoading: true,
              'Language-Code': this.languageCode
            },
          });
          if (resData.result != 200) return;
          this.params.id = resData.data
          this.getCountryList();
          this.getCountryInfo();
          this.$message.success("添加成功!");
        });
      });
    },
    //删除
    async del(row) {
      this.$confirm("一旦删除无法恢复, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$post(
            `/email/template/remove/${row.id}`,{},
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getCountryList();
        this.$message.success("删除成功!");
      });
    },
    //分页
    handleSizeChange(val) {
      this.pages.pageSize = val;
      this.getCountryList()
    },
    handleCurrentChange(val) {
      this.pages.pageNo = val;
      this.getCountryList()
    },
  },
};
</script>

<style lang="scss" scoped>
.role {
  display: flex;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;

  .fa-line {
    display: block;
    border-right: 1px solid #ccc;
  }

  &Left {
    padding-right: 15px;
    width: auto;

    &_List {
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin-top: 20px;
    }
  }

  &Right {
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;
    padding-left: 15px;
    border-left: 1px solid #ccc;

    &_Top {
      display: flex;
      gap: 15px;

      .el-input {
        width: auto;
      }
    }

    &_Container {
      margin-top: 20px;
    }

    &_pagenation {
      margin: 40px auto;
    }

    ::v-deep .el-table th,
    ::v-deep .el-table td {
      text-align: center !important;
    }
  }
}
</style>
